import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-bottom: 30px;
`;
